import { render } from "./LeaveActivityPopup.vue?vue&type=template&id=522b024b&scoped=true"
import script from "./LeaveActivityPopup.vue?vue&type=script&lang=js"
export * from "./LeaveActivityPopup.vue?vue&type=script&lang=js"

import "./LeaveActivityPopup.vue?vue&type=style&index=0&id=522b024b&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522b024b"]])

export default __exports__